import React from 'react';
import { Box, Typography } from '@mui/material';

interface LogoProps {
  variant?: 'full' | 'compact';
  color?: string;
}

const Logo: React.FC<LogoProps> = ({ variant = 'full', color = 'inherit' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '1.2rem',
        }}
      >
        RO
      </Box>
      {variant === 'full' && (
        <Typography
          variant="h6"
          sx={{
            color,
            fontWeight: 'bold',
            display: { xs: 'none', sm: 'block' },
          }}
        >
          Richard Otieno
        </Typography>
      )}
    </Box>
  );
};

export default Logo; 